// extracted by mini-css-extract-plugin
export default {"tenantTable":"TenantEntries_tenantTable__V+ltf"};